import { Calendar, Dumbbell, ClipboardCheck, Trophy, Zap, Award, MessageSquareText, UserCog, ArrowRight } from "lucide-react";

const fmt = (d) => { try { return new Date(d).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); } catch { return d; } };
const fmtDT = (d) => { try { return new Date(d).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }); } catch { return d; } };

function Card({ icon: Icon, title, testid, onClick, children }) {
  return (
    <button data-testid={testid} onClick={onClick}
      className="group text-left bg-[#121212] border border-white/10 p-5 hover:border-white/25 transition-colors flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <span className="flex items-center gap-2 font-mono-accent text-[10px] tracking-[0.2em] uppercase text-white/40"><Icon size={14} /> {title}</span>
        <ArrowRight size={14} className="text-white/20 group-hover:text-white/60 transition-colors" />
      </div>
      <div className="flex-1">{children}</div>
    </button>
  );
}
const Empty = ({ children }) => <p className="text-white/35 text-sm leading-relaxed">{children}</p>;

export default function OverviewCards({ dash, onNav }) {
  const c = dash?.cards || {};
  const sp = dash?.speed_points || {};
  const pc = dash?.profile_completion || {};
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="overview-cards">
      <Card icon={Calendar} title="Next Session" testid="card-next-session" onClick={() => onNav("schedule")}>
        {c.next_session ? (<><p className="font-bold text-sm">{c.next_session.title}</p><p className="text-white/50 text-xs mt-1">{fmtDT(c.next_session.start_time)}</p></>) : <Empty>Your upcoming sessions will appear here.</Empty>}
      </Card>
      <Card icon={Dumbbell} title="Current Workout" testid="card-current-workout" onClick={() => onNav("training")}>
        {c.current_workout ? <p className="font-bold text-sm">{c.current_workout.title}</p> : <Empty>Your coach has not assigned a workout yet.</Empty>}
      </Card>
      <Card icon={ClipboardCheck} title="Latest Evaluation" testid="card-latest-eval" onClick={() => onNav("evaluations")}>
        {c.latest_evaluation ? (<><p className="font-bold text-sm">Speed Score {c.latest_evaluation.speed_score ?? "—"}</p><p className="text-white/50 text-xs mt-1">{fmt(c.latest_evaluation.date)}</p></>) : <Empty>No evaluation results have been added yet.</Empty>}
      </Card>
      <Card icon={Trophy} title="Latest PR" testid="card-latest-pr" onClick={() => onNav("evaluations")}>
        {c.latest_pr ? (<><p className="font-bold text-sm">{c.latest_pr.label}: {c.latest_pr.current}{c.latest_pr.unit}</p><p className="text-white/50 text-xs mt-1">{fmt(c.latest_pr.date)}</p></>) : <Empty>Set your first personal record by completing a test.</Empty>}
      </Card>
      <Card icon={Zap} title="Speed Points" testid="card-speed-points" onClick={() => onNav("achievements")}>
        <p className="font-display font-black text-3xl leading-none">{sp.lifetime ?? 0}</p><p className="text-white/40 text-[10px] uppercase tracking-widest mt-1">Lifetime · +{sp.current ?? 0} this month</p>
      </Card>
      <Card icon={Award} title="Recent Achievement" testid="card-recent-achievement" onClick={() => onNav("achievements")}>
        {c.recent_achievement ? <p className="font-bold text-sm">{c.recent_achievement.title}</p> : <Empty>Earn badges as you train and hit milestones.</Empty>}
      </Card>
      <Card icon={MessageSquareText} title="Coach Messages" testid="card-messages" onClick={() => onNav("messages")}>
        {c.unread_messages > 0 ? <p className="font-bold text-sm">{c.unread_messages} unread message{c.unread_messages > 1 ? "s" : ""}</p> : <Empty>No new messages from your coach.</Empty>}
      </Card>
      <Card icon={UserCog} title="Profile Completion" testid="card-profile-completion" onClick={() => onNav("profile")}>
        <p className="font-display font-black text-3xl leading-none">{pc.pct ?? 0}%</p>
        <p className="text-white/40 text-[10px] uppercase tracking-widest mt-1">{pc.pct >= 100 ? "All set" : "Complete your profile to personalize training"}</p>
      </Card>
    </div>
  );
}
